import _ from 'lodash';
import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common entities => display containers => ');

const add = createAction('add display container', (displayContainers) =>
  _.isArray(displayContainers) ? { displayContainers } : { displayContainers: [displayContainers] }
);
const expireAll = createAction('expire all');

const fetchWithEmbedCodes = createAction('fetch containers with embed codes', (channelId, status) => ({
  channelId,
  status,
}));
const fetchWithEmbedCodesSuccess = createAction('fetch containers with embed codes success', (displayContainers) => ({
  displayContainers,
}));
const fetchWithEmbedCodesFailure = createApiFailureAction('fetch containers with embed codes failure', (error) => ({
  error,
}));

const removeDisplayContainer = createAction('remove display container', (id) => ({ id }));

const resetDisplayContainer = createAction('reset display container', (container) => ({ container }));

// update individual fields in the channel model
const updateContainer = createAction('update container', (containerId, update) => ({ containerId, update }));

const deleteContainer = createAction('delete container', (containerId) => ({ containerId }));
const deleteContainerSuccess = createAction('delete container success', (id) => ({ id }));
const deleteContainerFailure = createApiFailureAction('delete container failure', (error) => ({ error }));

const publishContainer = createAction('publish container', (containerId) => ({ containerId }));
const publishContainerSuccess = createAction('publish container success', (container) => ({ container }));
const publishContainerFailure = createApiFailureAction('publish container failure', (error) => ({ error }));

const expireContainer = createAction('expire container', (containerId) => ({ containerId }));
const expireContainerSuccess = createAction('expire container success', (container) => ({ container }));
const expireContainerFailure = createApiFailureAction('expire container failure', (error) => ({ error }));

const setRoot = createAction('set container as root', (containerId) => ({ containerId }));
const setRootSuccess = createAction('set container as root success', (container) => ({ container }));
const setRootFailure = createApiFailureAction('set container as root failure');

const setDefault = createAction('set container as default', (containerId) => ({ containerId }));
const setDefaultSuccess = createAction('set container as default success', (container) => ({ container }));
const setDefaultFailure = createApiFailureAction('set container as default failure');

const saveDisplayContainer = createAction('update active display container', (displayContainer) => ({
  displayContainer,
}));
const saveDisplayContainerSuccess = createAction('update display container success', (container) => ({
  container,
}));
const saveDisplayContainerFailure = createApiFailureAction('update display container failure', (error) => ({
  error,
}));

const tryFetchThirdPartyProviderCode = createAction('try fetch third party code');
const fetchThirdPartyProviderCode = createAction('fetch third party code');
const fetchThirdPartyProviderCodeSuccess = createAction(
  'fetch third party code success',
  (thirdPartyProviderCode, formatType) => ({
    thirdPartyProviderCode,
    formatType,
  })
);
const fetchThirdPartyProviderCodeFailure = createApiFailureAction('fetch third party code failure');

export default {
  add,

  deleteContainer,
  deleteContainerFailure,
  deleteContainerSuccess,

  expireAll,
  expireContainer,
  expireContainerFailure,
  expireContainerSuccess,

  fetchWithEmbedCodes,
  fetchWithEmbedCodesFailure,
  fetchWithEmbedCodesSuccess,

  publishContainer,
  publishContainerFailure,
  publishContainerSuccess,

  removeDisplayContainer,

  resetDisplayContainer,

  saveDisplayContainer,
  saveDisplayContainerFailure,
  saveDisplayContainerSuccess,

  setRoot,
  setRootSuccess,
  setRootFailure,

  setDefault,
  setDefaultSuccess,
  setDefaultFailure,

  updateContainer,

  tryFetchThirdPartyProviderCode,
  fetchThirdPartyProviderCode,
  fetchThirdPartyProviderCodeSuccess,
  fetchThirdPartyProviderCodeFailure,
};
